module.exports = "../fonts/HelveticaNeueLTW01-75Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-75Bold.woff2
// module id = nmiE
// module chunks = 1